// Centralised site constants used by SEO + share metadata.
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || window.location.origin;

// Backend-rendered OG image endpoint. Same endpoint serves both the
// site-wide default and per-product images.
export const ogUrl = (slug = "default") =>
  `${process.env.REACT_APP_BACKEND_URL}/api/og/${slug}.png`;

export const DEFAULT_OG = ogUrl("default");
